import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const NotEmptyString = pipe(
	string,
	parse((s) => (s.trim().length > 0 ? success(s) : failure(s, 'must not be empty')))
);
